<template>
    <div class="component-navbar">
        <div class="navbar-container">
            <div class="logo-container fl">
               <img @click="toLoginPage" src="../../../static/img/logo.png" class="logo fl">
            </div>
            <div class="nav-container fl">
                <ul class="clearFix">
                    <li v-for="(item, index) of navList" :key="index" @click="toNavRoute(item, index)"
                     :class="{'active': activeIndex == index}">
                        {{item.name}}
                    </li>
                </ul>
            </div>
            <div class="right-container fr" v-show="userName">
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item command="1">个人中心</el-dropdown-item>
                        <el-dropdown-item command="orderList">订单列表</el-dropdown-item>
                        <el-dropdown-item command="2">修改密码</el-dropdown-item> -->
                        <el-dropdown-item command="3" @click="outLogin">{{$t('LogOut')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="switchLang">
                        <span class="el-dropdown-link lang-wrapper">
                            {{langText}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="zh">中文</el-dropdown-item>
                            <el-dropdown-item command="en">English</el-dropdown-item>
                        </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="right-container fr" v-show="!userName">
                <span class="to-login">
                    <span @click="toLogin(1)" class="my-hover">登录</span> / <span @click="toLogin(2)" class="my-hover">注册</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'Navbar',
    data () {
        return {
            navList: [{
                name: this.$i18n.t('SeaFullContainer'),
                routeName: 'SeaTransportation'
            }, {
                name: this.$i18n.t('LandFullContainer'),
                routeName: 'LandTransportation'
            }, {
                name: this.$i18n.t('SeaFreightExportLCL'),
                routeName: 'SeaPieceTransportation'
            }, {
                name: this.$i18n.t('ExpressQuotationQuery'),
                routeName: 'CourierQueryOffer'
            }, 
            // {
            //     name: '偏远查询',
            //     routeName: 'Transportation'
            // }
            ],
            activeIndex: -1,
            langText: '中文'
        }
    },
    computed: {
        userName () {
            return sessionStorage.getItem('userName');
        }
    },
    mounted () {
        if (sessionStorage.getItem('topNavSctiveIndex')) {
            this.activeIndex =  sessionStorage.getItem('topNavSctiveIndex')
        } else {
            let nameArr = ['SeaTransportation', 'LandTransportation', 'SeaPieceTransportation', 'CourierQueryOffer'];
            this.activeIndex = nameArr.indexOf(this.$route.name);
        }
        if (localStorage.getItem('locale')) {
            let obj = {
                zh: '中文',
                en: 'English'
            }
            this.langText = obj[localStorage.getItem('locale')];
        }
    },
    methods: {
        toLoginPage () {
            this.$router.push({name: 'Login'});
        },
        // 切换语言
        switchLang (command) {
            let obj = {
                zh: '中文',
                en: 'English'
            }
            this.langText = obj[command];
            this.$i18n.locale = command;
            localStorage.setItem('locale', command);
            location.reload();
        },
        toLogin (type) {
            this.$router.push({name: 'Login', query: {
                type: type
            }})
        },
        toNavRoute (item, index) {
            if (item.routeName == this.$route.name) {
                return;
            }
            sessionStorage.setItem('topNavSctiveIndex', index);
            this.activeIndex = index;
            this.$router.push({name: item.routeName});
        },
        handleCommand(command) {
            switch (command) {
                case '1':
                    break;
                case 'orderList':
                    this.$router.push({name: 'UserOrderList'})
                    break;
                case '2':
                    break;
                case '3':
                    this.outLogin();
                    break;
            }
        },
        async outLogin () {
            await this.$store.dispatch('app/logout');
            this.$router.push({name: 'Login'})
        }
    }
}
</script>

<style lang="scss" scoped>
.component-navbar {
    height: 50px;
    background-color: #325da7;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    .navbar-container {
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;
    }
    .logo-container {
        margin-right: 10px;
        .logo {
            margin-top: 10px;
            height: 30px;
        }
    }
    .nav-container {
        ul {
            li {
                position: relative;
                float: left;
                font-size: 14px;
                color: rgba(255, 255, 255, .9);
                line-height: 50px;
                padding: 0 10px;
                margin-right: 10px;
                transition: all .3s;
                &::after {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 2px;
                    width: 0;
                    background: #fff;
                    transition: all .3s;
                }
                &:last-child {
                    margin-right: 0;
                }
                &:hover {
                    cursor: pointer;
                    color: #fff;
                    background-color: #4567a2;
                    &::after {
                        width: 100%;
                    }
                }
                &.active {
                    &::after {
                        width: 100%;
                    }
                }
            }
        }
    }
    .right-container {
        margin-right: 50px;
        height: 100%;
        .el-dropdown {
            height: 100%;
            .el-dropdown-link {
                display: inline-block;
                font-size: 14px;
                color: #fff;
                outline: none;
                height: 100%;
                line-height: 50px;
                cursor: pointer;
            }
        }
        .to-login {
            display: inline-block;
            font-size: 14px;
            color: #fff;
            height: 100%;
            line-height: 50px;
        }
    }
}
.lang-wrapper {
    margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue